// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-table:not(.data-table--themed) {
  white-space: nowrap;
}
.data-table:not(.data-table--themed) td,
.data-table:not(.data-table--themed) th {
  padding: 5px 10px;
}
.data-table:not(.data-table--themed) td:first-child,
.data-table:not(.data-table--themed) th:first-child {
  padding-left: 0;
}
.data-table:not(.data-table--themed) td:last-child,
.data-table:not(.data-table--themed) th:last-child {
  padding-right: 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
